module.exports = __webpack_public_path__ + "img/Avatar-Homme.67e3e393.png";